import { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Stepper,
  Step,
  StepIndicator,
  StepStatus,
  StepIcon,
  StepNumber,
  StepTitle,
  StepSeparator,
  Image,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
// import { projectCall } from "../../api/project";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { saleOpeningEventCall } from "../../api/saleOpeningEvent";
import { exportFile } from "../../utils/tools";
import Step1 from "./step1";
import Step2 from "./step2";

const schemaAdd = Yup.object().shape({
  saleOpeningEventId: Yup.string().required("mã dự án là bắt buộc"),
});

const TableUpdateProjectMechanismImport = ({ saleOpeningEventId }) => {
  const [files, setFiles] = useState(null);
  const [product, setProduct] = useState([]);

  const {
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaAdd),
    defaultValues:
      {
        saleOpeningEventId,
        // period,
      } || {},
  });

  const getProject = async (saleOpeningEventId) => {
    try {
      const data = await saleOpeningEventCall.getId(saleOpeningEventId);

      if (data?.apartmentSaleOpeningEventLink) {
        setProduct(data.apartmentSaleOpeningEventLink);
      }
    } catch (error) {
      console.error("Error", error);
      toast.error("Có lỗi xảy ra khi lấy ra dự án");
    }
  };

  useEffect(() => {
    if (saleOpeningEventId) {
      getProject(saleOpeningEventId);
    }
  }, [saleOpeningEventId]);

  const steps = [{ title: "Bước 1: Chuẩn bị file import" }, { title: "Bước 2: Import thưởng nóng và giá tính PDV" }];


  const [activeStep, setActiveStep] = useState(1);
  const handleNext = () => {
    setActiveStep(2);
  };

  const handlePrevious = () => { console.log("dat")
    setActiveStep(1);
  };

  const dataSteps = [
    {
      step: 1,
      data: (
        <Step1
          saleOpeningEventId={saleOpeningEventId}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
    {
      step: 2,
      data: (
        <Step2
          saleOpeningEventId={saleOpeningEventId}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
        />
      ),
    },
  ];

  return (
    <>
      <Box w={"full"}>
        <Text
          fontSize={"20px"}
          lineHeight={"19px"}
          fontWeight={"600"}
          color={"var(--color-header-employee)"}
          mb={"16px"}
        >
          Import Giá tính PDV và TN sàn
        </Text>

        {/* 1 */}
        <Box
          w={{ base: "100%" }}
          backgroundColor="var(--color-main)"
          p={{ base: "24px 16px 16px" }}
        >
          <Box w={"100%"} mb={"20px"}>
            <Stepper w={"full"} index={activeStep - 1} count={steps.length}>
              {steps.map((step, index) => {
                return (
                  <Step key={index}>
                    <StepIndicator
                      fontSize={"16px"}
                      fontWeight={600}
                      color={"red"}
                      sx={{
                        bg: `${
                          activeStep > index + 1
                            ? "var(--color-status-employ)"
                            : "var(--color-option-employee-hover)"
                        } !important`,
                      }}
                      border={"none"}
                      outline={"none"}
                      w={"28px"}
                      h={"28px"}
                    >
                      <StepStatus
                        complete={<StepIcon />}
                        incomplete={<StepNumber color={"var(--color-main)"} />}
                        active={<StepNumber color={"var(--color-main)"} />}
                      />
                    </StepIndicator>

                    <Box flexShrink="0">
                      <StepTitle
                        sx={{
                          color: `${
                            activeStep > index + 1
                              ? "var(--color-status-employ)"
                              : "var(--color-info-employee)"
                          } !important`,
                        }}
                        onClick={() => { 
                          if (index === 0) {
                            handlePrevious();
                          }
                          if (index === 1) {
                            handleNext();
                          }
                        }}
                        cursor={"pointer"}
                      >
                        {step.title}
                      </StepTitle>
                    </Box>

                    <StepSeparator
                      sx={{
                        bg: `var(--color-black-2) !important`,
                      }}
                    />
                  </Step>
                );
              })}
            </Stepper>
          </Box>
          <Box padding={"25px 24px"}>{dataSteps[activeStep - 1]?.data}</Box>
        </Box>
      </Box>
    </>
  );
};

export default TableUpdateProjectMechanismImport;
